import {app} from '@/config/vue/app'

import power from "./src/power";
import preventReClick from "./src/preventReClick";
import emoji from "./src/emoji";
import letterToNum from "./src/letterToNum";
import intNumber from "./src/int";
import amount from "./src/amount";

[power, preventReClick, emoji, letterToNum, intNumber, amount].map(
    (directive: any) => app.directive(directive.name, directive));


